import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * @file index.tsx
 * @author markJia(markjia@tencent.com)
 */
import React from 'react';
import { useRefCallback } from '@tencent/glue-react-use';
import { DEFAULT_TRIGGER_STYLE, filesAcceptFilter } from '../FileTrigger';
import { withViewComponent } from '../../../hoc/withViewComponent';
export var ViewDropTrigger = withViewComponent(function ($p, $s, $c, $a) {
  var children = $p.children,
      _$p$accept = $p.accept,
      accept = _$p$accept === void 0 ? '*' : _$p$accept,
      _$p$disabled = $p.disabled,
      disabled = _$p$disabled === void 0 ? false : _$p$disabled,
      _$p$isMultiple = $p.isMultiple,
      isMultiple = _$p$isMultiple === void 0 ? false : _$p$isMultiple,
      onFileChange = $p.onFileChange;
  var drop = useRefCallback(function (ev) {
    ev.preventDefault();
    ev.stopPropagation();

    if (disabled) {
      return;
    }

    var fileList = ev.dataTransfer.files;
    var acceptFileList = filesAcceptFilter(fileList, accept);
    onFileChange === null || onFileChange === void 0 ? void 0 : onFileChange(isMultiple ? acceptFileList : acceptFileList.slice(0, 1));
  });
  return React.createElement("div", _objectSpread({
    className: $c(true, undefined, false),
    style: _objectSpread(_objectSpread({}, DEFAULT_TRIGGER_STYLE), $s),
    onDrop: drop,
    onDragOver: function onDragOver(e) {
      return e.preventDefault();
    }
  }, $a), children);
}, 'drop-trigger', ['children', 'accept', 'disabled', 'isMultiple', 'onFileChange']);